import type * as GraphQLTypes from '../../../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ApplyGiftCardOnPackageMutationVariables = GraphQLTypes.Exact<{
  code: GraphQLTypes.Scalars['String'];
  id: GraphQLTypes.Scalars['String'];
}>;


export type ApplyGiftCardOnPackageMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'applyGiftCardOnPackage'>
);


export const ApplyGiftCardOnPackageDocument = /*#__PURE__*/ gql`
    mutation applyGiftCardOnPackage($code: String!, $id: String!) {
  applyGiftCardOnPackage(code: $code, id: $id)
}
    `;

/**
 * __useApplyGiftCardOnPackageMutation__
 *
 * To run a mutation, you first call `useApplyGiftCardOnPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyGiftCardOnPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyGiftCardOnPackageMutation, { data, loading, error }] = useApplyGiftCardOnPackageMutation({
 *   variables: {
 *      code: // value for 'code'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplyGiftCardOnPackageMutation(baseOptions?: Apollo.MutationHookOptions<ApplyGiftCardOnPackageMutationResult, ApplyGiftCardOnPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyGiftCardOnPackageMutationResult, ApplyGiftCardOnPackageMutationVariables>(ApplyGiftCardOnPackageDocument, options);
      }
export type ApplyGiftCardOnPackageMutationHookResult = ReturnType<typeof useApplyGiftCardOnPackageMutation>;